<template>
    <div class="subusers-menu" ref="root">
        <button type="button" class="button button_icon" @click="isOpen = !isOpen" :title="$t('text.Subusers')">
            <SvgIcon name="user"/>
        </button>
        <div class="subusers-menu__dropdown" v-show="isOpen">
        <div class="subusers-menu__search" v-if="subusers.length > 10">
            <input type="text" v-model="search" :placeholder="$t('text.Search')">
        </div>
        <div class="subusers-menu__empty" v-if="subusers.length && !filteredSubusers.length">{{ $t('text.No data') }}</div>
        <ul class="subusers-menu__list" v-if="filteredSubusers.length">
            <li class="subusers-menu__item" v-for="user in filteredSubusers" :key="user.id">
                <span class="text-ellipsis" :title="user.login">{{ user.login }}</span>
                <div class="subusers-menu__actions" v-if="user.status == userStatus.ACTIVE">
                    <button
                        type="button"
                        class="button button_command"
                        :title="$t('text.Sign in to portal')"
                        @click="onLogin(user.id, 'portal_url')"
                    >
                        <SvgIcon class="icon" name="command__sign_in_portal"/>
                    </button>
                    <template v-if="$isTestVersion">
                        <button
                            type="button"
                            class="button button_command"
                            :title="$t('text.Sign in to admin')"
                            @click="onLogin(user.id, 'admin_url')"
                        >
                            <SvgIcon class="icon" name="command__sign_in_admin"/>
                        </button>
                        <button
                            type="button"
                            class="button button_command"
                            title="Sign in test portal"
                            @click="onLoginTest(user.id, $consts.testSites.portal)"
                        >
                            T
                        </button>
                        <button
                            type="button"
                            class="button button_command"
                            title="Sign in test admin"
                            @click="onLoginTest(user.id, $consts.testSites.admin)"
                        >
                            A
                        </button>
                    </template>
                </div>
            </li>
        </ul>
        <div class="subusers-menu__footer" v-if="canReturn">
            <button type="button" class="button button_view_outline subusers-menu__return" @click="returnToParent">
                {{ $t('text.Return to my account') }}
            </button>
        </div>
        </div>
        <custom-modal v-if="loginSiteModal" v-bind="loginSiteModal.props" teleport="body">
            <SectionLoading class="section_type_loader-center" v-if="loginSiteModal.inProgress"/>
            <p class="size-14" v-else>{{ $t('popup.Are you sure') }}</p>
        </custom-modal>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import {userStatus} from "@/lib/user-status";
import loginAsMixin from "@/mixins/loginAsMixin";
import {canReturnToParent, returnToParent} from "@/lib/auth-storage";

export default {
    name: "SubusersLoginMenu",
    mixins: [loginAsMixin],
    data() {
        return {
            userStatus,
            isOpen: false,
            search: '',
            canReturn: canReturnToParent(),
        }
    },
    computed: {
        ...mapGetters([
            "getAppUser",
            "getUsers",
        ]),
        subusers() {
            return this.getUsers
                .filter(u => u.id != this.getAppUser.id && u.status != userStatus.DELETED)
                .sort((a, b) => String(a.login).localeCompare(String(b.login)))
        },
        filteredSubusers() {
            const search = this.search.trim().toLowerCase()
            return this.subusers.filter(u => String(u.login).toLowerCase().includes(search))
        },
    },
    methods: {
        returnToParent,
        onDocumentClick(e) {
            if (!this.$refs.root.contains(e.target)) this.isOpen = false
        },
        onLogin(id, field) {
            this.isOpen = false
            this.loginPopup(id, field)
        },
        onLoginTest(id, site) {
            this.isOpen = false
            this.loginAs(id, site)
        },
    },
    mounted() {
        document.addEventListener('click', this.onDocumentClick)
    },
    beforeUnmount() {
        document.removeEventListener('click', this.onDocumentClick)
    },
}
</script>

<style lang="scss" scoped>
.subusers-menu {
    position: relative;
    display: flex;

    &__dropdown {
        position: absolute;
        top: calc(100% + 8px);
        left: 0;
        z-index: 100;
        display: flex;
        flex-direction: column;
        width: 360px;
        max-height: 24rem;
        background: var(--dropdown-menu-bg);
        border-radius: var(--border-radius-lg);
        box-shadow: 0 2px 6px 0 rgba(80, 99, 121, 0.30);
        cursor: default;
    }
    &__search {
        flex-shrink: 0;
        padding: 8px 12px;

        input {
            width: 100%;
            padding: 6px 8px;
            color: var(--color-font);
            background: transparent;
            border: 1px solid var(--color-neutral-150);
            border-radius: 4px;
        }
    }
    &__empty {
        padding: 8px 12px;
        color: var(--color-font);
    }
    &__list {
        min-height: 0;
        overflow: auto;
        padding: 4px 0;
        @include scroll(var(--section-list-scroll-bg), var(--section-list-scroll-item), 6px);
    }
    &__footer {
        flex-shrink: 0;
        padding: 8px 12px;
        border-top: 1px solid var(--color-neutral-150);
    }
    &__return {
        width: 100%;
        justify-content: center;
    }
    &__item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        padding: 0 8px 0 12px;
        color: var(--color-font);
    }
    &__actions {
        display: flex;
        flex-shrink: 0;
    }
}

</style>
